import { createAsyncThunk } from "@reduxjs/toolkit";
import { EnumData, EnumResponse } from "../model/Enum";
import * as services from "../services/enumService";

export const fetchEnumsByType = createAsyncThunk(
    "enumManager/fetchEnumsByType",
    async (type: string): Promise<EnumResponse> => {
        const enums = await services.fetchEnumsByType(type);
        return { enums: enums, type: type };
    }
);

export const deleteEnum = createAsyncThunk(
    "enumManager/deleteEnum",
    async (enumData: EnumData): Promise<EnumData[]> => {
        await services.deleteEnum({ id: enumData.id, type: enumData.type });
        const enums = await services.fetchEnumsByType(enumData.type);
        return enums;
    }
);

export const updateEnum = createAsyncThunk(
    "enumManager/updateEnum",
    async (enumData: EnumData): Promise<EnumData[]> => {
        await services.updateEnum(enumData);
        const enums = await services.fetchEnumsByType(enumData.type);
        return enums;
    }
);
